<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="账号:">
          <el-input
            v-model="searchValue.username"
            placeholder="请填写账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
            @clear="gameClear"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in channelSelectList"
              :key="i"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额范围:">
          <div class="scope">
            <el-input v-model="payNum1" placeholder="填写数值"></el-input>
            <span>-</span>
            <el-input v-model="payNum2" placeholder="填写数值"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="最后登录时间:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchpayTopList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportPayTop()">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="user_id" label="账号ID"> </el-table-column>
      <el-table-column prop="username" label="账号"> </el-table-column>
      <el-table-column prop="phone" label="手机"> </el-table-column>
      <el-table-column prop="last_login_at" label="最近登录时间">
      </el-table-column>
      <el-table-column prop="max_paid_at" label="最近充值时间">
      </el-table-column>
      <el-table-column prop="amount" label="充值金额"> </el-table-column>
      <el-table-column prop="roll_user" label="是否滚服"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            title=""
            @click="payTopDetail(scope.row.user_id)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[15, 30, 45, 60]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible">
      <el-table
        stripe
        :data="detailData"
        v-loading="detailLoadingData"
        border
        style="width: 100%"
      >
        <el-table-column prop="user_name" label="账号"> </el-table-column>
        <el-table-column prop="game_name" label="游戏"> </el-table-column>
        <el-table-column prop="channel_name" label="渠道"> </el-table-column>
        <el-table-column prop="zone_name" label="区服"> </el-table-column>
        <el-table-column prop="role_name" label="角色名"> </el-table-column>
        <el-table-column prop="last_login_at" label="最近登录时间">
        </el-table-column>
        <el-table-column prop="max_paid_at" label="最近充值时间">
        </el-table-column>
        <el-table-column prop="amount" label="充值金额"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "payTop",
  components: {},
  data() {
    return {
      loadingData: false,
      detailLoadingData: false,
      detailDialogVisible: false,
      searchValue: {
        username: "",
        game_id: "",
        channel_id: [],
        zone_id: [],
        start_at: "",
        end_at: "",
        money: "",
      },
      value1: [],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      loginDetailData: [],
      channelSelectList: [],
      channelSelectAllList: [],
      serverSelectList: [],
      channelGroupSelectList: [],
      systemList: [],
      detailData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 15,
      payNum1: "",
      payNum2: "",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.value1[0] = moment().startOf("month").format("YYYY-MM-DD");
    this.value1[1] = moment().endOf("month").format("YYYY-MM-DD");

    this.searchValue.start_at = this.value1[0];
    this.searchValue.end_at = this.value1[1];
    this.getchannelSelectList();
    this.getGameSelectList();
    this.getpayTopList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getpayTopList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getpayTopList(false);
    },

    // 导出
    exportPayTop() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/payTop/list", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data;
        }
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectAllList = res.data.data;
          this.channelSelectList = res.data.data;
        }
      });
    },

    // 获取区服选择列表数据
    getServerSelectList(vid) {
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },

    // 根据所属游戏,显示对应的所属渠道/区服
    selectChannel(vid) {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (item.game_id == vid) {
          this.channelSelectList.push(item);
        }
      });
      if (vid) {
        this.getServerSelectList(vid);
      }
    },
    // 清空游戏选项
    gameClear() {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.serverSelectList = [];

      this.getchannelSelectList();
    },
    // 实现充值排行榜数据的搜索
    searchpayTopList() {
      this.searchValue.start_at = this.value1[0];
      this.searchValue.end_at = this.value1[1];
      this.currentPage = 1;
      this.getpayTopList(true);
    },

    // 获取详情列表
    payTopDetail(vid) {
      this.detailDialogVisible = true;
      this.detailLoadingData = true;
      fetch({
        url: "/admin/payRoleTop/list",
        method: "GET",
        params: {
          user_id: vid,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.detailData = res.data.data;
          }
        })
        .finally(() => {
          this.detailLoadingData = false;
        });
    },

    //获取 充值排行榜 列表
    getpayTopList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      let zone_id = this.searchValue.zone_id.toString();
      if (this.payNum1 == "" && this.payNum2 == "") {
        this.searchValue.money = "";
      } else {
        this.searchValue.money = this.payNum1 + "-" + this.payNum2;
      }
      fetch({
        url: "/admin/payTop/list",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          zone_id: zone_id,
          money: this.searchValue.money,
          page: this.currentPage,
          limit: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.scope {
  display: flex;
  span {
    display: inline-block;
    padding: 0 10px;
  }
  .el-input {
    width: 100px;
  }
}
</style>
